module.exports = __webpack_public_path__ + "img/t5.aef35f66.png";